import axios from "axios";
import { defineStore } from "pinia";

import { IRonTransaction } from "@/types/IRonTransaction";
import { IAkdrTransaction } from "@/types/IAkdrTransaction";
import type { IResponseWrapper } from "@/types/IResponseWrapper";
import { getOffsetByPageNumber } from "@/helpers/getOffsetByPageNumber";

const TRANSACTIONS_PER_REQUEST_LIMIT = 100;

const BASE_URL = "https://skynet-api.roninchain.com/ronin/explorer/v2";
const KAIDRO_AKDR_ADDRESS = "0xe3c587e40e9b89b3f2af526c9d468d49a66e3c2d";
const KAIDRO_RON_ADDRESS = "0xfd7ee5e1dfa1990c3cc6742eaae4bcf1ff6b516e";

export const useHttpServiceStore = defineStore("useHttpServiceStore", () => {
  return {
    async getAkdrLockTransactions(walletAddress: string, page = 1) {
      const {
        data: {
          result: { items },
        },
      } = await axios.get<IResponseWrapper<IAkdrTransaction>>(
        `${BASE_URL}/accounts/${walletAddress}/tokens/${KAIDRO_AKDR_ADDRESS}/transfers`,
        {
          params: {
            offset: getOffsetByPageNumber(page, TRANSACTIONS_PER_REQUEST_LIMIT),
            limit: TRANSACTIONS_PER_REQUEST_LIMIT,
          },
        },
      );

      return items;
    },

    // @DEPRECATED
    async getRonLockTransactions(page = 1) {
      const {
        data: {
          result: { items },
        },
      } = await axios.get<IResponseWrapper<IRonTransaction>>(
        `${BASE_URL}/accounts/${KAIDRO_RON_ADDRESS}/txs`,
        {
          params: {
            offset: getOffsetByPageNumber(page, TRANSACTIONS_PER_REQUEST_LIMIT),
            limit: TRANSACTIONS_PER_REQUEST_LIMIT,
          },
        },
      );

      return items;
    },
  };
});
